(() => {
  const init = (root) => {
    if (root.dataset.sliderReady === 'true') return;

    const slides = [...root.querySelectorAll('[data-custom-hero-slide]')]
      .sort((a, b) => Number(a.dataset.slideOrder) - Number(b.dataset.slideOrder));
    if (slides.length < 2) return;

    const dotsContainer = root.querySelector('[data-custom-hero-dots]');
    const controls = root.querySelector('.custom-hero-slider__controls, .campaign-slider__controls');
    slides.forEach((slide) => root.insertBefore(slide, controls));
    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'custom-hero-slider__dot';
      dot.dataset.customHeroDot = index;
      dot.setAttribute('aria-label', `Show slide ${index + 1}`);
      dotsContainer?.appendChild(dot);
    });
    const dots = [...root.querySelectorAll('[data-custom-hero-dot]')];

    root.dataset.sliderReady = 'true';
    let current = 0;
    let timer;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    };

    const autoplay = () => {
      window.clearInterval(timer);
      if (root.dataset.autoplay !== 'true') return;
      const interval = Math.max(3000, Number(root.dataset.interval) || 6500);
      timer = window.setInterval(() => show(current + 1), interval);
    };

    root.querySelector('[data-custom-hero-prev]')?.addEventListener('click', () => {
      show(current - 1);
      autoplay();
    });
    root.querySelector('[data-custom-hero-next]')?.addEventListener('click', () => {
      show(current + 1);
      autoplay();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.customHeroDot));
      autoplay();
    }));

    root.addEventListener('mouseenter', () => window.clearInterval(timer));
    root.addEventListener('mouseleave', autoplay);
    show(0);
    autoplay();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-custom-hero-slider]').forEach(init);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
